import { useQuery } from "@apollo/client/react";
import { Anchor, Badge, Group, Loader } from "@mantine/core";
import { ResultOf, graphql } from "gql.tada";
import { Link } from "react-router-dom";
import { AutoDataTable } from "../../components/AutoDataTable";

const EMAIL_TEMPLATE_CONFIGURATIONS_QUERY = graphql(`
  query EmailTemplateConfigurations {
    emailTemplateConfigurations {
      name
      triggerEvent
    }
  }
`);

const EMAIL_TEMPLATE_QUERY = graphql(`
  query EmailTemplates($cursor: String, $count: Float) {
    emailTemplates(page: { after: $cursor, first: $count }) {
      nodes {
        id
        name
        triggerEvent
        default
      }
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`);

const EMAIL_TEMPLATE_DELETE_MUTATION = graphql(`
  mutation EmailTemplateDelete($id: ID!) {
    emailTemplateDelete(id: $id) {
      id
    }
  }
`);

export const EmailsList = () => {
  const { data: emailTemplateConfigurations, loading } = useQuery<any>(
    EMAIL_TEMPLATE_CONFIGURATIONS_QUERY,
  );

  if (loading) {
    return <Loader />;
  }

  return (
    <AutoDataTable
      createButtonText="Create new email template"
      deleteMutation={EMAIL_TEMPLATE_DELETE_MUTATION}
      query={EMAIL_TEMPLATE_QUERY}
      columns={[
        {
          accessor: "name",
          title: "Name",
          rawElement: (
            row: ResultOf<
              typeof EMAIL_TEMPLATE_QUERY
            >["emailTemplates"]["nodes"][number],
          ) => {
            return (
              <Group>
                <Anchor component={Link} to={row.id}>
                  {row.name}
                </Anchor>
                {row.default && <Badge>Default</Badge>}
              </Group>
            );
          },
        },
        {
          accessor: "triggerEvent",
          title: "Trigger event",
          rawElement: (
            row: ResultOf<
              typeof EMAIL_TEMPLATE_QUERY
            >["emailTemplates"]["nodes"][number],
          ) => {
            return (
              emailTemplateConfigurations?.emailTemplateConfigurations.find(
                (config: any) => config.triggerEvent === row.triggerEvent,
              )?.name ?? row.triggerEvent
            );
          },
        },
      ]}
    />
  );
};
